export const SELECT_DROPDOWN_RENDER_TYPE = {
  acceptable: 'acceptable',
  excluded: 'excluded'
} as const
